import { useMemo } from 'react';

import getImageBySize from '@/common/helpers/getImageBySize';

/**
 * Custom hook to get image alt and src
 * @param {object} image - The image object
 * @param {string} format - The format string
 * @returns {object} - An object containing the image alt and src
 */
const useImage = ({ image, format }) => {
  const getImageAlt = useMemo(() => image && image?.alt, [image]);

  const getImageSrc = useMemo(
    () => (image && image?.url ? getImageBySize(image?.url, format) : ''),
    [format, image],
  );

  return {
    alt: getImageAlt,
    src: getImageSrc,
  };
};

export default useImage;
